import FeedbackService from './feedbackService';

export function sendFeedback(
  baseURL: string,
  thumbsUp: boolean,
  message: string,
  transactionID: string,
  transactionName: string
) {
  return new FeedbackService(baseURL).sendFeedback(
    thumbsUp,
    message,
    transactionID,
    transactionName
  );
}
